// extracted by mini-css-extract-plugin
export default {"root":"mimic___style_root__a61dl","iconBox":"mimic___style_iconBox__jPHUH","iconError":"mimic___style_iconError__RG0YL"};